/* eslint-disable import/first */
import React from 'react';
import classNames from 'classnames';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';

const CustomizedBox = ({ customizeDescription, className = '', onCustomize, productObj }) => {
  const isCustomized = productObj?.customized === 1 || productObj?.customized === true || false;
  return (
    <div className={classNames(css.customizedBox, className)}>
      {!isCustomized ? (
        <p>
          {productObj?.description?.length < 100
            ? productObj?.description
            : productObj?.description?.substring(0, 100) + '...'}
        </p>
      ) : (
        ''
      )}
      {isCustomized ? (
        <p>
          <em>
            <FormattedMessage id="CUSTOMIZED" defaultMessage="CUSTOMIZED" />
          </em>
          {customizeDescription}
        </p>
      ) : (
        ''
      )}
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        className={css.hideDesktop}
        onClick={onCustomize}
      >
        <FormattedMessage id="customizeEdit" defaultMessage="Edit" />
      </Button>
      {/* <p>
        <em>Customized: </em>
        {/* Commenting out the ellipsis for now till we figure out a more reliable method */}
      {/*customizeDescription.length < 100
          ? customizeDescription
        : customizeDescription.substring(0, 100) + '...'*/}
      {/* {customizeDescription}
        <span onClick={onCustomize}>EDIT</span>
      </p>  */}
      {/* TODO: change it during customization page <h5>Add-ons -></h5> */}
    </div>
  );
};

export default CustomizedBox;
